module.exports = __webpack_public_path__ + "536efed0452b1c0a9f99ece3ed415aa3.pdf";